import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';

const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL
}
const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
  SiigoAuth: localStorage.getItem('siigo_token'),
}

const toQueryString = (input) =>
  typeof input === 'string'
    ? input.replace(/^\?/, '')
    : new URLSearchParams(input || {}).toString();

export function* getCuentas() {

  const res = yield gaxios.request({
    url: 'api/contabilidad/cuentas',
    headers
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_CUENTAS_SUCCESS,
      payload: res.data.cuentas,
    });
  }
}

export function* getMovimientos(action) {
  const { filters } = action;
  const res = yield gaxios.request({
    url: 'api/contabilidad/movimientos?' + filters,
    headers,
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_MOVIMIENTOS_SUCCESS,
      payload: res.data.data,
    });
  }
}

export function* editCuentas(action) {
  const { id, payload } = action;

  const res = yield gaxios.request({
    url: `api/contabilidad/cuentas/${id}`,
    method: 'PUT',
    headers,
    data: payload
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', 'Cuenta actualizada con éxito');
    yield put({
      type: actions.EDIT_CUENTA_SUCCESS,
      payload: res.data,
    });
  }
}

export function* createMovimiento(action) {
  const { payload, history } = action;

  const res = yield gaxios.request({
    url: `api/caja/comprobante`,
    method: 'POST',
    headers,
    data: payload
  });
  console.log(res)
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', 'Movimiento creado con éxito');
    history.push('/dashboard/contabilidad/movimientos');
  }
}

export function* getMovimientosInformes(action) {
  const { filters } = action;
  const res = yield gaxios.request({
    url: 'api/contabilidad/movimientos/informes?' + filters,
    headers,
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_MOVIMIENTOS_INFORMES_SUCCESS,
      payload: res.data.data,
    });
  }
}

export function* getCierres(action) {
  const { filters } = action;
  const res = yield gaxios.request({
    url: 'api/contabilidad/cierres-contables?' + filters,
    headers,
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_CIERRES_SUCCESS,
      payload: res.data.cierres,
    });
  }
}

export function* getSaldos(action) {
  const { filters } = action;

  const query = toQueryString(filters);
  const res = yield gaxios.request({
    url: `api/contabilidad/saldos${query ? `?${query}` : ''}`,
    headers,
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    yield put({
      type: actions.GET_SALDOS_SUCCESS,
      payload: res.data.saldos,
    });
  }
}

export function* crearCierre(action) {
  const res = yield gaxios.request({
    url: `api/contabilidad/cierres-contables`,
    method: 'POST',
    headers,
    data: action.payload
  });
  if (!res.data.success) {
    notification('error', res.data.msg);
  } else {
    notification('success', 'Cierre contable creado con éxito');
    console.log(res.data)
    yield put({
      type: actions.CREATE_CIERRE_SUCCESS,
      payload: res.data.cierre,
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_CUENTAS_REQUEST, getCuentas),
    yield takeEvery(actions.GET_MOVIMIENTOS_REQUEST, getMovimientos),
    yield takeEvery(actions.EDIT_CUENTA_REQUEST, editCuentas),
    yield takeEvery(actions.CREATE_MOVIMIENTO_REQUEST, createMovimiento),
    yield takeEvery(actions.GET_MOVIMIENTOS_INFORMES_REQUEST, getMovimientosInformes),
    yield takeEvery(actions.GET_CIERRES_REQUEST, getCierres),
    yield takeEvery(actions.GET_SALDOS_REQUEST, getSaldos),
    yield takeEvery(actions.CREATE_CIERRE_REQUEST, crearCierre),
  ]);
}
